import type { IGoogleAdsAdText } from '@feathr/blackbox';
import { objectId } from '@feathr/hooks';

import { AD_TEXT_LIMITS } from '../GoogleAdsCampaignEdit.utils';
import type { IAdGroupKeyword, ISitelink } from './AdStep.types';
import { DEFAULT_KEYWORD_MATCH_TYPE } from './AdStep.types';

/*
 * Blank rows for the ad group editor. Keyword and sitelink keys are minted client-side
 * because the API identifies those rows by a key the client owns — unlike ad groups and
 * ads, which are documents the server assigns ids to.
 */

export function createAdText(text = ''): IGoogleAdsAdText {
  return { key: objectId(), text };
}

/** The empty headline rows a new ad starts with: as many as policy requires. */
export function createBlankHeadlines(): IGoogleAdsAdText[] {
  return Array.from({ length: AD_TEXT_LIMITS.headline.minItems }, () => createAdText());
}

export function createBlankDescriptions(): IGoogleAdsAdText[] {
  return Array.from({ length: AD_TEXT_LIMITS.description.minItems }, () => createAdText());
}

export function createSitelink(): ISitelink {
  return { key: objectId(), text: '', url: '' };
}

export function createKeyword(
  text: string,
  matchType = DEFAULT_KEYWORD_MATCH_TYPE,
): IAdGroupKeyword {
  return { key: objectId(), text, matchType };
}
